import { UserRole } from '@pya-mms/common';

export type MembershipCategory = 'member' | 'partner' | 'non-member';

export interface MembershipTypeOption {
  id: string;
  title: string;
  typeSlug?: string;
  rate: number;
  currency: string;
  frequency: string;
  duration: number;
}

export interface WizardFormData {
  // Step 1: Category
  category: MembershipCategory | '';

  // Step 2: Plan Selection (skipped for non-members)
  membershipType: string;

  // Step 3: User Details
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  dateOfBirth: Date | undefined;
  password: string;

  // Step 4: Terms
  termsAndConditionsAccepted: boolean;

  // Derived values
  isActive?: boolean;
  userRole?: UserRole;
}

export const WizardFormDataBlank: WizardFormData = {
  category: '',
  membershipType: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  dateOfBirth: undefined,
  password: '',
  termsAndConditionsAccepted: false,
};

export interface WizardStep {
  id: string;
  label: string;
  hidden?: boolean;
}

export const WIZARD_STEPS: WizardStep[] = [
  { id: 'category', label: 'Category' },
  { id: 'plan', label: 'Plan' },
  { id: 'details', label: 'Details' },
  { id: 'terms', label: 'Terms' },
  { id: 'payment', label: 'Payment' },
];

// Step indices
export const STEP_CATEGORY = 0;
export const STEP_PLAN = 1;
export const STEP_DETAILS = 2;
export const STEP_TERMS = 3;
export const STEP_PAYMENT = 4;
